import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=d623c79c&scoped=true&"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d623c79c",
  null
  
)

export default component.exports